var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGrammar = function SvgGrammar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#grammar_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.4,
    stroke: "#fff",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.318 9.036c-.169 1.118-.897 1.898-2.106 1.898-1.482 0-2.392-1.235-2.392-2.925S6.743 5.11 8.16 5.11c1.066 0 1.599.546 1.924 1.404h1.352c-.312-1.586-1.443-2.626-3.276-2.626-2.08 0-3.705 1.664-3.705 4.121s1.612 4.121 3.757 4.121c1.95 0 3.393-1.417 3.393-3.627v-.624H8.576v1.157z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "grammar_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export { SvgGrammar as ReactComponent };